import { useState, useEffect, useCallback } from "react";

export function useExitIntent(onExitIntent: () => void, options?: { mobileThreshold?: number; cooldownMs?: number }) {
  const [hasTriggered, setHasTriggered] = useState(false);
  const { mobileThreshold = 0.5, cooldownMs = 10000 } = options || {};

  const trigger = useCallback(() => {
    if (hasTriggered) return;
    setHasTriggered(true);
    onExitIntent();
    setTimeout(() => setHasTriggered(false), cooldownMs);
  }, [hasTriggered, onExitIntent, cooldownMs]);

  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      let lastScrollY = window.scrollY;
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = currentScrollY / docHeight;

        if (scrollPercent > mobileThreshold && currentScrollY < lastScrollY) {
          trigger();
        }
        lastScrollY = currentScrollY;
      };
      window.addEventListener("scroll", handleScroll, { passive: true });
      return () => window.removeEventListener("scroll", handleScroll);
    } else {
      const handleMouseLeave = (e: MouseEvent) => {
        if (e.clientY <= 0) {
          trigger();
        }
      };
      document.addEventListener("mouseleave", handleMouseLeave);
      return () => document.removeEventListener("mouseleave", handleMouseLeave);
    }
  }, [trigger, mobileThreshold]);

  return { hasTriggered };
}
